import { createNamespacedHelpers } from 'vuex'

const {
  mapActions: mapActionsShipping,
  mapState: mapStateShipping,
  mapGetters: mapGettersShipping,
} = createNamespacedHelpers('shipping')

export default ({ app, store }, inject) => {
  const shippingActions = {
    $store: store,
    ...mapActionsShipping([
      'setShippingAddressForItems',
      'setShippingForItems',
      'setShippingData',
      'updateShipping',
      'setIsSameAsShippingSent',
    ]),
  }

  // @todo używać getersow lub zmiana nazw, ustalic system aliasow
  const shippingState = {
    $store: store,
    ...mapStateShipping({
      shipping: state => state.shipping,
      finalShippingPrice: state => state.finalShippingPrice,
      isSameAsShippingSent: state => state.isSameAsShippingSent,
    }),
  }
  const shippingGetters = {
    $store: store,
    ...mapGettersShipping([
      'getSelectedShippingItems',
      'getFinalShippingPrice',
      'isSameAsShippingSent',
    ]),
  }

  inject('shipping', {
    ...shippingState,
    ...shippingActions,
    ...shippingGetters,
  })
}
